import {ControllerFieldState} from 'react-hook-form';

const ErrorText = (props: ControllerFieldState) => {
  const {invalid, error} = props;
  if (!invalid || !error?.message) return null;

  return (
    <div className="" slot="errorMessage">
      <span className="mt-2 text-sm text-red-600 dark:text-red-500">
        <p> {error.message} </p>
      </span>
    </div>
  );
};

export default ErrorText;
